import React from "react";

const STATUS = {
  ok: { label: "Elaborata", cls: "bg-emerald-100 text-emerald-700" },
  no_serial: { label: "Seriale non trovato", cls: "bg-red-100 text-red-700" },
  ignored: { label: "Oggetto non riconosciuto", cls: "bg-slate-100 text-slate-600" },
};
const ACTION = {
  loaded_traveling: "caricato su viaggiante",
  already_installed: "già installato (scartato)",
  already_loaded: "già sul furgone del tecnico (scartato)",
  created_installed: "non in giacenza → creato e installato",
  created_traveling: "non in giacenza → creato e caricato al tecnico",
  installed_from_warehouse: "installato (da magazzino)",
  installed_from_traveling: "installato (da viaggiante)",
  installed_from_assigned: "installato",
};
const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "—");

export function MailLogTable({ items }) {
  return (
    <div className="overflow-x-auto rounded-sm border border-slate-200 bg-white" data-testid="mail-log-table">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
          <tr><th className="p-3">Letta il</th><th className="p-3">Tecnico</th><th className="p-3">Oggetto</th><th className="p-3">Tipo</th><th className="p-3">Seriali</th><th className="p-3">Esito</th></tr>
        </thead>
        <tbody>
          {items.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-slate-400">Nessuna mail elaborata finora</td></tr>}
          {items.map((m, i) => {
            const st = STATUS[m.status] || STATUS.ignored;
            return (
              <tr key={m.message_id || i} className="border-t border-slate-100 align-top" data-testid={`mail-log-row-${i}`}>
                <td className="whitespace-nowrap p-3 text-xs text-slate-500">{fmt(m.processed_at)}</td>
                <td className="p-3 font-semibold text-slate-800">{m.technician_name}</td>
                <td className="p-3 text-slate-700">{m.subject}</td>
                <td className="whitespace-nowrap p-3 text-xs">{m.mode === "pickup" ? "Materiale ritirato" : m.mode === "install" ? "Chiusura impianto" : "—"}</td>
                <td className="p-3 text-xs">
                  {(m.serials || []).map((s) => (
                    <div key={s.serial}><span className="mono font-semibold">{s.serial}</span> <span className="text-slate-500">· {ACTION[s.action] || s.action}</span></div>
                  ))}
                </td>
                <td className="p-3"><span className={`rounded-full px-2 py-0.5 text-[11px] font-bold ${st.cls}`}>{st.label}</span></td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
